import { faExchangeAlt } from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { FilterWidget, TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { ToggleFilter } from 'searchCards/ToggleFilter';

const FILTER = TOGGLE_FILTERS.onSaleFilter;

export const widget = ({
  startsOpen = true,
}: {
  startsOpen?: boolean;
} = {}): FilterWidget => ({
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: () => (
    <ToggleFilter
      icon={<FontAwesomeIcon icon={faExchangeAlt} />}
      filter={FILTER}
    />
  ),
  accordionOptions: { startsOpen },
});
